export const CURRENT_EVENT_SEASON = "2025";